import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';

const linkStyle = (isActive: boolean): React.CSSProperties => ({
  display: 'flex',
  alignItems: 'center',
  gap: 10,
  padding: '10px 16px',
  borderRadius: 8,
  textDecoration: 'none',
  color: isActive ? '#1677ff' : '#555',
  background: isActive ? '#e6f4ff' : 'transparent',
  fontWeight: isActive ? 600 : 400,
  transition: 'background 0.15s, color 0.15s',
  fontSize: 14,
  marginBottom: 4,
});

const Layout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem('token');
    navigate('/login');
  };

  return (
    <div style={{ display: 'flex', minHeight: '100vh', fontFamily: '"Inter", "Roboto", "Segoe UI", sans-serif' }}>
      {/* Боковая панель */}
      <aside style={{
        width: 240,
        background: 'white',
        padding: '20px 16px',
        boxShadow: '2px 0 12px rgba(0,0,0,0.04)',
        display: 'flex',
        flexDirection: 'column',
      }}>
        <div style={{ fontWeight: 700, fontSize: 18, marginBottom: 28, padding: '0 8px' }}>
          🤖 MAX Bot
        </div>

        <nav style={{ flex: 1 }}>
          <NavLink to="/dashboard" style={({ isActive }) => linkStyle(isActive)}>
            🏠 Дашборд
          </NavLink>
          <NavLink to="/scenarios" style={({ isActive }) => linkStyle(isActive)}>
            🎭 Сценарии
          </NavLink>
          <NavLink to="/broadcasts" style={({ isActive }) => linkStyle(isActive)}>
            📢 Рассылки
          </NavLink>
          <NavLink to="/livechat" style={({ isActive }) => linkStyle(isActive)}>
            💬 Live‑чат
          </NavLink>
          <NavLink to="/settings" style={({ isActive }) => linkStyle(isActive)}>
            ⚙️ Настройки
          </NavLink>
        </nav>

        <button
          onClick={handleLogout}
          style={{
            marginTop: 'auto',
            padding: '8px 16px',
            borderRadius: 8,
            border: '1px solid #e0e0e0',
            background: 'white',
            cursor: 'pointer',
            fontSize: 13,
            fontWeight: 500,
            color: '#888',
          }}
        >
          Выйти
        </button>
      </aside>

      {/* Основная область */}
      <main style={{ flex: 1, background: '#f0f2f5', overflowY: 'auto' }}>
        {children}
      </main>
    </div>
  );
};

export default Layout;